import _ from 'lodash'
import { tokenState } from "../auth/tokenState";
import { Persister, usePersister } from "../utils/persister";
import { createContext, PropsWithChildren, useContext, useEffect } from "react";
import { useAuthValidation } from "@/hooks/useAuthValidation";

interface AuthContextValue {
  isLoggedIn: boolean;
  accessToken: string | null;
  isValidating: boolean;
}

const AuthContext = createContext<AuthContextValue>({
  isLoggedIn: false,
  accessToken: "",
  isValidating: false,
});

export function useAuthContext() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }: PropsWithChildren<{}>) {
  const [refreshToken] = usePersister(tokenState.accessToken);
  const accessToken = tokenState.accessToken?.get()
  const { isAuthenticated, isLoading: isValidating } = useAuthValidation();
  
  // Use token presence initially, but defer to validation result once available
  const isLoggedIn = isValidating ? !_.isNil(accessToken) : (isAuthenticated && !_.isNil(accessToken));

  return (
    <AuthContext.Provider value={{ isLoggedIn, accessToken, isValidating }}>
      {children}
    </AuthContext.Provider>
  );
}
